const hostname = ''
const statichostname = ''
const base = '/v1'

//  const hostname = 'http://34.96.200.93:8082'
//  const statichostname = 'http://34.96.200.93:8082'
//  const base = '/manager/v1'

// const hostname = 'http://dashboard.mycashfly.com'
// const statichostname = 'http://dashboard.mycashfly.com'
// const base = '/manager/v1'

// const hostname = 'http://dashboard.xpesoph.com/'
// const statichostname = 'http://dashboard.xpesoph.com/'
// const base = '/manager/v1'

const login_url = base + '/login'
const logout_url = base + '/logout'
const system_user_url = base + '/systemUser'
const changePassword_url = base + '/stateless'
const system_user_info_url = base + '/systemUser/info'
const audit_order_url = base + '/audit/order'
const product_url = base + '/product'
const payout_url = base + '/payout'
const repay_record_url = base + '/repayRecord'
const role_url = base + '/systemRole'
const role_permission_url = base + '/systemRolePermission'
const permission_url = base + '/systemPermission'
const user_url = base + '/user'
const userInfo_url = base + '/userInfo'
const order_url = base + '/order'
const vorder_url = base + '/vorder'
const bussiness_Operation_record_url = base + '/operation'
const repayment_plan_url = base + '/repaymentPlan'
const finance_url = base + '/finance'
const bank_reconcilliation_url = base + '/bankStatement'
const payout_queue_url = base + '/payoutQueue'
const reject_reason_url = base + '/audit/order/getRejectReason'
const operation_reason_url = base + '/audit/order/getOperationReason'
const remain_url = base + '/audit/order/remain'
const check_url = base + '/audit/order/checkInfo'
const audit_history_url = base + '/audit/history'
const audit_history_export_url = base + '/audit/history'
const inner_message_url = base + '/innerMessage'
const key_url=base+"/key"
const payout_import_template_url = 'import.xlsx'
const banner_url = base + '/banner'
const app_key_url = base+'/appKey'
const faq_url = base+'/appFAQ'

export {
    hostname,
    login_url,
    logout_url,
    system_user_url,
    changePassword_url,
    system_user_info_url,
    audit_order_url,
    product_url,
    payout_url,

    role_url,
    role_permission_url,
    permission_url,
    user_url,
    repay_record_url,
    userInfo_url,
    order_url,
    vorder_url,
    bussiness_Operation_record_url,

    repayment_plan_url,
    finance_url,
    statichostname,

    payout_import_template_url,
    bank_reconcilliation_url,
    payout_queue_url,
    reject_reason_url,
    operation_reason_url,
    remain_url,
    check_url,
    audit_history_url,
    audit_history_export_url,
    inner_message_url,
    banner_url,

    key_url,

    app_key_url,

    faq_url
}
